import * as ActionTypes from 'actions';

const initialState = {
  content: 'Tandem',
  showBack: false,
  backTitle: '',
  rightAction: '',
};

export default function(state = initialState, action = {}) {
  const { header, showBack, backTitle, rightAction, type } = action;

  switch (type) {
  case ActionTypes.SET_HEADER:
    return {
      content: header,
      showBack,
      backTitle,
      rightAction,
    };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/header.js